/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query AccessTokenReadQuery($bindToTable: String!, $bindableId: ID!) {
    AccessTokenRead(bindToTable: $bindToTable, bindableId: $bindableId) {
      id,
      token,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
